export default {
  init() {
    // JavaScript to be fired on all pages
    /* eslint-disable */
    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
    });

    // function sticktothetop() {
    //   var window_top = $(window).scrollTop();
    //   var top = $('#stick-here').offset().top;
    //   if (window_top > top) {
    //     $('.sticky-wrapper').addClass('sticky');
    //     // $('#stick-here').height($('#stickThis').outerHeight());
    //   } else {
    //     $('.sticky-wrapper').removeClass('sticky');
    //     // $('#stick-here').height(0);
    //   }
    // }
    // $(function() {
    //   $(window).scroll(sticktothetop);
    //   sticktothetop();
    // });

    $(".post").fitVids();
    $(".panel-heading").fitVids();
    $(".entry-content").fitVids();
    $("main .featured-image").fitVids();
    $("main .featured-video").fitVids();
    $(".entry-content-asset").fitVids();
    $(".entry-content-asset").fitVids();
    $(".fitvids").fitVids();

    $('.carousel-inner').each(function() {
      if ($(this).children('div').length === 1) $(this).siblings('.carousel-control, .carousel-indicators').hide();
    });

    

    // show arrows on Bootstrap accordion
    $('.panel-collapse').on('show.bs.collapse', function () {
      $(this).siblings('.panel-heading').addClass('active');
    });

    $('.panel-collapse').on('hide.bs.collapse', function () {
      $(this).siblings('.panel-heading').removeClass('active');
    });

    /* eslint-enable */
  },
  finalize() {
     // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js